import { LoanActionsButton } from '../LoanComponents';

export const onActionCellRender = (e, isPropLevel = false) => {
    return (
        <LoanActionsButton
            data={e.data}
            isPropertyLevel={isPropLevel}
        />
    );
};
